import {Injectable} from '@angular/core';
import {NavFactory} from './nav.factory';
import {NavItemCodes} from '../../enums/nav-item-codes.enum';
import {IconCode} from '../../enums/icon-code.enum';
import {PermissionArea} from '../../enums/permission-area.enum';

@Injectable()
export class NavReportFactory extends NavFactory {
    protected static items = [
        {
            code: NavItemCodes.REPORTS_LIST,
            icon: IconCode.REPORTS_LIST,
            label: 'NAV.REPORTS_LIST.LABEL',
            description: 'NAV.REPORTS_LIST.DESC',
            path: '/reports',
            permissionArea: [PermissionArea.MARKETING_REPORT, PermissionArea.USERS_REPORT],
            cy: 'reports'
        },
        {
            code: NavItemCodes.REPORT_VIEW,
            icon: IconCode.REPORTS_LIST,
            label: 'REPORTS.REPORT',
        },
    ];
}
